"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const validations_1 = require("../../../utils/validations");
const TrackerMessage_1 = __importDefault(require("../TrackerMessage"));
class StatusMessage extends TrackerMessage_1.default {
    constructor({ version = TrackerMessage_1.default.LATEST_VERSION, requestId, status }) {
        super(version, TrackerMessage_1.default.TYPES.StatusMessage, requestId);
        (0, validations_1.validateIsNotNullOrUndefined)('status', status);
        this.status = status;
    }
}
exports.default = StatusMessage;
//# sourceMappingURL=StatusMessage.js.map